module.exports = __webpack_public_path__ + "../front/img/divide2.fce03d9a.svg";